import i18next from 'i18next';

export const ActionTypes = {
    PARSE_OPTIONS: 'PARSE_OPTIONS',
    SET_LANGUAGE: 'SET_LANGUAGE',
    SET_VIDEO_TITLE: 'SET_VIDEO_TITLE',
    TOGGLE_HEATMAP: 'TOGGLE_HEATMAP',
    TOGGLE_TRANSCRIPT: 'TOGGLE_TRANSCRIPT',
    TOGGLE_CAPTIONS: 'TOGGLE_CAPTIONS',
    TOGGLE_SPEAKERS: 'TOGGLE_SPEAKERS',
    TOGGLE_WORD_HIGHLIGHT: 'TOGGLE_WORD_HIGHLIGHT',
    TOGGLE_SHARE_TIME: 'TOGGLE_SHARE_TIME',
    TOGGLE_SHARE_SEARCH: 'TOGGLE_SHARE_SEARCH',
    UPDATE_SHARE_URL: 'UPDATE_SHARE_URL',
    INITIAL_RENDER: 'INITIAL_RENDER',
    INIT_READY: 'INIT_READY',
};

export const parseOptions = (options) => ({
    type: ActionTypes.PARSE_OPTIONS,
    options,
});

export const setLanguage = (language) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_LANGUAGE,
        language,
    });
    i18next.changeLanguage(language);
};

export const setVideoTitle = (videoTitle) => ({
    type: ActionTypes.SET_VIDEO_TITLE,
    videoTitle,
});

export const toggleHeatmap = (visible) => ({
    type: ActionTypes.TOGGLE_HEATMAP,
    visible,
});

export const toggleTranscript = (visible) => ({
    type: ActionTypes.TOGGLE_TRANSCRIPT,
    visible,
});

export const toggleCaptions = (visible) => ({
    type: ActionTypes.TOGGLE_CAPTIONS,
    visible,
});

export const toggleSpeakers = (visible) => ({
    type: ActionTypes.TOGGLE_SPEAKERS,
    visible,
});

export const toggleWordHighlight = (visible) => ({
    type: ActionTypes.TOGGLE_WORD_HIGHLIGHT,
    visible,
});

export const toggleShareTime = () => ({
    type: ActionTypes.TOGGLE_SHARE_TIME,
});

export const toggleShareSearch = () => ({
    type: ActionTypes.TOGGLE_SHARE_SEARCH,
});

export const updateShareUrl = () => (dispatch, getState) => {
    const currentTime = getState().video.get('currentTime');
    dispatch({
        type: ActionTypes.UPDATE_SHARE_URL,
        currentTime,
    });
};

export const initialRender = () => ({
    type: ActionTypes.INITIAL_RENDER,
});

export const initReady = () => ({
    type: ActionTypes.INIT_READY,
});



// WEBPACK FOOTER //
// ./scripts/store/config/actions.js